import React from 'react';
/* Helpers */
import { objectIsEmpty } from '../../../helpers/utils';
/* Components */
import { Button } from '../Button';
/* CSS */
import './style.css';

export const Modal = ({ content = {}, button = {} }) => {
  return (
    <div className="custom-modal">
      { typeof content === "object" && !objectIsEmpty(content) ? (<p className="custom-modal__text">{content.text}</p>) : null}
      { typeof button === "object" && !objectIsEmpty(button) ? (<Button className="custom-modal__button" isRecap={true} text={button.text} clickEvent={button.clickEvent} />) : null}
    </div>
  );
}
